import axiosInstance from "@/api/axios-instance";

export async function updateReachedOut(
  usage_id: string,
  user_id: string,
  value: boolean,
) {
  const response = await axiosInstance.patch(
    `/usage/${usage_id}/reached-out`,
    { user_id, value },
  );

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to update reached out status");
  }

  return response.data;
}
